import React from 'react';

import ErrorBlock from '@/modules/core/components/ErrorBlock';

const ErrorPage = () => (
  <ErrorBlock />
);

export default ErrorPage;
